export default["__VITE_ASSET__DCdMPB1f__","__VITE_ASSET__BxSRfE$x__"];